<style lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .box {
        padding: 15px 15px 15px 15px;
        background: #ffffff;
    }

    .h155{
        height: 155px;
    }

    .happy-scroll-content{
        width:90% !important;
    }

</style>
<template>
    <div class="box h155">
        <happy-scroll size="5"
                      bigger-move-h="end"
                      color="rgba(0,0,0,0.5)"
                      resize>
            <div>
                <dis_message_item v-for="(message,index) in list" :infoObj="message" :key="index">
                    <!--<section class="date" slot="date">{{ message.sendTime | formateDate }}</section>-->
                </dis_message_item>
            </div>
        </happy-scroll>
    </div>
</template>

<script>
    import dis_message_item from "./dis-message-item"
    import {disService} from "../../lib/service/dis"
    export default {
        name: "dis-message-box",
        components: {dis_message_item},
        data(){
            return {
                list:[]
            }
        },
        methods: {
           async  getMsg(id){
                const {list} = await disService.getMsgList({
                    outpatientId:id
                })
               this.list = list.reverse();
            }
        },
    }
</script>
